import styled from "styled-components";
import { Flex } from "@evergis/ui";

export const LayerOpacityContainer = styled(Flex)`
  align-items: center;
  gap: 0.25rem;
  width: calc(100% - 3rem);
  padding: 0.25rem 1.5rem 0;
  border-top: 1px solid rgba(151, 151, 151, 0.28);
`;

export const SliderContainer = styled.div`
  flex: 1;
  margin: 0 0.5rem;
`;

export const LayerOpacityValue = styled.div`
  font-size: 0.75rem;
  user-select: none;
`;
